import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import PartNumber from 'pu-react/components/PartNumber';
import Revision from 'pu-react/components/Revision';
import GerberFile from './ZipFile';

import { changeGlobalParameter } from 'product_tabs/actions';

import { changeParameter, validatorProject as validator } from '../pcb_fabrication/fabricationSlice';

const Project = () => {
  const dispatch = useDispatch();
  const {
    parametersCustomer,
  } = useSelector((state) => state.fabrication)

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }))
    dispatch(changeGlobalParameter({ name, value }))
  }
  const props = {
    parameters: parametersCustomer,
    onChangeParameter,
  };

  return (
    <div className="project-information row">
      <div className="col-lg-2">
        <PartNumber
          {...props}
          errorMessage={validator.message('Part Number', parametersCustomer.part_number, 'required|min:3')} />
      </div>
      <div className="col-lg-2">
        <Revision
          {...props}
          errorMessage={validator.message('Revision', parametersCustomer.revision, 'required')} />
      </div>
      <div className="col-lg-2">
        <GerberFile
          {...props}
          label="Upload Zip File"
          text="Browse"
          validator={validator} />
      </div>
    </div>
  )
};

export default Project;
